import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table menu-wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 根菜单 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_tree = _resolveComponent("a-tree")
  const _component_set_menu = _resolveComponent("set-menu")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_a_button, {
            class: "menu-action-link",
            type: "link",
            title: "添加菜单",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAction(_ctx.record)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon, {
                scale: "1.5",
                name: "icon_add"
              })
            ]),
            _: 1
          })
        ]),
        (_ctx.menuData.length)
          ? (_openBlock(), _createBlock(_component_a_tree, {
              key: 0,
              "show-line": _ctx.showLine,
              selectable: false,
              "show-icon": _ctx.showIcon,
              defaultExpandAll: true,
              onExpand: _ctx.onExpand,
              onSelect: _ctx.onSelect,
              replaceFields: _ctx.replaceFields,
              "tree-data": _ctx.menuData
            }, {
              title: _withCtx((record) => [
                _createTextVNode(_toDisplayString(record.name) + "【" + _toDisplayString(record.code) + "】 ", 1),
                _createVNode(_component_a_button, {
                  class: "menu-action-link",
                  type: "link",
                  title: "添加菜单",
                  onClick: ($event: any) => (_ctx.addAction(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon, {
                      scale: "1.5",
                      name: "icon_add"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "menu-action-link",
                  title: "编辑菜单",
                  name: "",
                  onClick: ($event: any) => (_ctx.configMenuAction(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon, {
                      scale: "1.5",
                      name: "edit"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["show-line", "show-icon", "onExpand", "onSelect", "replaceFields", "tree-data"]))
          : _createCommentVNode("", true),
        (_ctx.store.state.menu.setMenuState)
          ? (_openBlock(), _createBlock(_component_set_menu, {
              key: 1,
              onSuccess: _ctx.fetchList
            }, null, 8, ["onSuccess"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}